import React from "react";
import Usernav from "./Usernav";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Wishlist.css";
import GetSingleProduct from "./GetSingleProduct";
import Loader from "../Util/Loader";
import emptyWishList from "../assets/image/Empty Wishlist.svg";
import BaseURL from "../Util/BaseURL";
const Wishlist = () => {
  const [products, setProducts] = useState();
  async function getWishlistDetails() {
    const r = await axios.get(
      `${BaseURL}GetWish?name=${sessionStorage.getItem("user")}`,
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    setProducts(r.data);
  }
  useEffect(() => {
    getWishlistDetails();
  }, []);
  return (
    <>
      <Usernav />
      {products ? (
        <>
          {products.length === 0 ? (
            <>
              <section id="hero">
                <div className="hero-container">
                  <div className="hero-logo">
                    <h1 className="font-weight-bold">Your Wishlist is Empty</h1>
                  </div>
                </div>
              </section>
              <img
                src={emptyWishList}
                className="d-block d-xl-none d-lg-none d-md-none"
                style={{ width: "100%" }}
              />
              <img
                src={emptyWishList}
                className="d-none d-xl-block d-lg-block d-md-block mx-auto"
                style={{ width: "35%" }}
              />
            </>
          ) : (
            <>
              <section id="hero">
                <div className="hero-container">
                  <div className="hero-logo">
                    <h1 className="font-weight-bold">Your Wishlist</h1>
                  </div>
                </div>
              </section>
              <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 total h-100 w-100 mx-auto">
                {products
                  ? products.map((data,key) => (
                      <GetSingleProduct key={key} data={data.productid} />
                    ))
                  : ""}
              </div>
            </>
          )}
        </>
      ) : (
        <>{Loader()}</>
      )}
    </>
  );
};

export default Wishlist;
